"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useMutateGeneric = _interopRequireDefault(require("./useMutateGeneric"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useMutateCustomProperties = _ref => {
  let {
    endpoint,
    id,
    ...mutateGenericProps
  } = _ref;
  return (0, _useMutateGeneric.default)({
    endpoint,
    endpointMutators: {
      delete: () => `${endpoint}/${id}`,
      put: () => `${endpoint}/${id}`
    },
    id,
    queryKey: ['stripes-kint-components', 'useMutateCustomProperties', id],
    ...mutateGenericProps
  });
};
var _default = exports.default = useMutateCustomProperties;